import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { FormatterProvider } from "./providers/formatter";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

if (process.env.NODE_ENV !== "production") {
  const originalConsoleError = console.error;

  console.error = (...args) => {
    const message = args
      .map((arg) => {
        if (typeof arg === "string") {
          return arg;
        }

        if (arg instanceof Error) {
          return arg.message;
        }

        return "";
      })
      .join(" ");

    const isMuiDatatablesDeprecation =
      (message.includes("Failed") &&
        message.includes("buttonRef") &&
        message.includes("ForwardRef(ButtonBase)") &&
        message.includes("deprecated")) ||
      (message.includes("Failed") &&
        message.includes("onExited") &&
        message.includes("ForwardRef(Popover)") &&
        message.includes("deprecated"));

    if (isMuiDatatablesDeprecation) {
      return;
    }

    originalConsoleError(...args);
  };
}

ReactDOM.render(
  <FormatterProvider>
    <App />
  </FormatterProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.register();
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
